import StoreOrderStepBadge from '@/dealers/components/StoreOrderStepBadge'
import A from '@/gf/components/A'
import PaymentStatusBadge from '@/gf/components/PaymentStatusBadge'
import { Table, Tbody, Td, Thead, Tr } from '@/gf/components/Table'
import Tooltip from '@/gf/components/Tooltip'
import MoneyContext from '@/gf/modules/Money'
import RequestForQuoteContext from '@/gf/modules/RequestForQuote'
import Time from '@/gf/modules/Time'
import { OrderReportingMetrics } from '../hooks/useOrderReportingMetrics'

const ReportingTableOrder = ({
  allStoreOrders,
  linkPrefix = '',
}: {
  allStoreOrders: OrderReportingMetrics['allStoreOrders']
  linkPrefix?: string
}) => (
  <Table>
    <Thead>
      <Tr>
        <Td>Gross Part Sales</Td>
        <Td>
          Net Part Sales
          <Tooltip
            className="inline-block align-bottom ml-1"
            size="small"
            text="Gross Part Sales minus amount refunded."
          />
        </Td>
        <Td>Order</Td>
        <Td>Order Created At</Td>
        <Td>Order State</Td>
        <Td>RFQ</Td>
        <Td>RFQ Owner</Td>
      </Tr>
    </Thead>
    <Tbody>
      {allStoreOrders.length === 0 ? (
        <Tr>
          <Td colSpan={99}>No results found.</Td>
        </Tr>
      ) : (
        allStoreOrders.map(({ total, netTotal, storeOrder, requestForQuote }) => (
          <Tr key={storeOrder.id}>
            <Td>${MoneyContext.toString(total)}</Td>
            <Td>${MoneyContext.toString(netTotal)}</Td>
            <Td>
              <A.T href={`${linkPrefix}/orders/${storeOrder.id}`} target="_blank">
                {storeOrder.shortId}
              </A.T>
            </Td>
            <Td>{Time.toString(storeOrder.insertedAt)}</Td>
            <Td className="space-x-2">
              <StoreOrderStepBadge step={storeOrder.step} />
              <PaymentStatusBadge paymentStatus={storeOrder.paymentStatus} />
            </Td>
            <Td>
              {requestForQuote && (
                <A.T href={`${linkPrefix}/rfqs/${requestForQuote.id}`} target="_blank">
                  {requestForQuote.shortId}
                </A.T>
              )}
            </Td>
            <Td>
              {requestForQuote && RequestForQuoteContext.ownersToString(requestForQuote.owners)}
            </Td>
          </Tr>
        ))
      )}
    </Tbody>
  </Table>
)

export default ReportingTableOrder
